// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-logo {
    /* padding: 2px; */
    padding-right: 5px !important;
}

.short-logo {
    border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/Logo/Logo.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".full-logo {\n    /* padding: 2px; */\n    padding-right: 5px !important;\n}\n\n.short-logo {\n    border-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
